import React from 'react';
import {
  IndexContainer,
  MainBadgeContainer,
  TitleContainer
} from '../../styles/SamplesBadge.styled';

type SamplesBadgeProps = {
  title: string;
  number: number;
  totalNumber: number;
};
export const SamplesBadge = ({
  title,
  number,
  totalNumber
}: SamplesBadgeProps) => {
  return (
    <MainBadgeContainer>
      <TitleContainer>{title}</TitleContainer>
      <IndexContainer>
        {number}/{totalNumber}
      </IndexContainer>
    </MainBadgeContainer>
  );
};
